const styles = {
    default: {
      overflow: 'hidden',
      // Add any other CSS styles here
    },
  };
  
  export default styles;